import { Avatar } from "../../components";
import { playerName, type PublicPlayer } from "../types";
/** Eligible targets only: ineligible seats are not rendered as disabled
 * pseudo-buttons. Abstain is a separate full-width row, outside the grid, so it
 * never reads as another player. */
export function PlayerChoices({
  players,
  eligibleIds,
  selectedId,
  onSelect,
  disabled = false,
  allowAbstain = false,
  offlineIds,
}: {
  players: PublicPlayer[];
  eligibleIds: string[];
  selectedId: string | null;
  onSelect: (id: string) => void;
  disabled?: boolean;
  allowAbstain?: boolean;
  /** Public connection state: a seat shown as offline is still choosable. */
  offlineIds?: readonly string[];
}) {
  const count = players.filter((p) => eligibleIds.includes(p.id)).length;
  return (
    <div className="play-choice-block" data-tour="choices">
      <div
        className={`play-player-choices${count > 6 ? " is-large" : ""}${count > 9 ? " is-crowded" : ""}${count <= 3 ? " is-few" : ""}`}
        role="group"
        aria-label="Choose a player"
      >
        {players.map((p, i) =>
          eligibleIds.includes(p.id) ? (
            <button
              type="button"
              key={p.id}
              disabled={disabled}
              aria-pressed={selectedId === p.id}
              onClick={() => onSelect(p.id)}
            >
              <Avatar name={p.name} index={i} small />
              <span className="choice-name">
                {playerName(players, p.id)}
                {offlineIds?.includes(p.id) ? (
                  <small className="choice-offline">Offline</small>
                ) : null}
              </span>
              <span className="choice-check" aria-hidden="true" />
            </button>
          ) : null,
        )}
      </div>
      {allowAbstain ? (
        <button
          type="button"
          className="play-abstain"
          data-tour="abstain"
          disabled={disabled}
          aria-pressed={selectedId === "abstain"}
          onClick={() => onSelect("abstain")}
        >
          <span>Abstain</span>
          <span className="choice-check" aria-hidden="true" />
        </button>
      ) : null}
    </div>
  );
}
